import React from 'react';
import { useTheme } from '@mui/material/styles';
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import Grow from '@mui/material/Grow';
//import Fade from '@mui/material/Fade';
import Bs4Kartoteka from '../Bs4Kartoteka'

export const Bs4Popper = React.forwardRef((props, ref) => {
  const {slotProps, boundary, ...other} = props  
  const theme = useTheme();
  const [visibility, setVisibility] = React.useState(true)
  const [transform, setTransform] = React.useState(null)
  const [refPaperX, setRefPaper] = React.useState(null);
  const refPaper = React.useRef(null);
  const handleClickAway = (event) => {
    // console.log('...Bs4Popper.ClickAway..', event)
    if (props.onClose) props.onClose(event);
  }

  React.useEffect(() => {
    if (!props.bs4kartotekaid) {
      return;
    }

    const bs4Kartoteka = Bs4Kartoteka.get(props.bs4kartotekaid);
    bs4Kartoteka.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);    

    return () => {
      const bs4Kartoteka = Bs4Kartoteka.get(props.bs4kartotekaid);
      if (bs4Kartoteka) bs4Kartoteka.off(setVisibility);
    }
  }, [setVisibility])  

  React.useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries.find(entry => entry.target === refPaper.current);
      if (!entry) return;
      const rect = entry.contentRect;
      // console.log('...SCALE...1', window.screen.width, rect.width);
      if (rect.width > window.screen.width) {  
        const width = rect.width + 8;
        const height = rect.height + 8;
        const scale = window.screen.width / width;
        const x = (width - scale * width) / 2;
        const y = (height - scale * height) / 2;
        setTransform(`scale(${scale}) translate(${-x}px, ${y}px)`);
      } else {
        setTransform(null);
      }
    });
    if (refPaper.current) resizeObserver.observe(refPaper.current);
    
    return () => {
      resizeObserver.disconnect();
    }
  }, [refPaper.current, setTransform])

  // console.log('...Bs4Popper...', transform)
  
  return (
    <ClickAwayListener 
      onClickAway={handleClickAway}
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
    >
      <Popper
        sx={{zIndex: theme.zIndex.modal, visibility: visibility ? Bs4Kartoteka.VISIBILITY_VISIBLE : Bs4Kartoteka.VISIBILITY_HIDDEN}}
        placement='bottom-start'
        // placement='top-start'
        {...other}        
        transition
        modifiers={boundary ? [
          {
            name: "preventOverflow",
            options: {
              boundary: boundary
            }
          }
        ] : null}
      >
        {({ TransitionProps }) => (          
          <Grow 
            {...TransitionProps} 
            timeout={200} 
            style={{ transformOrigin: '0 0 0' }}
          >
            <Box>
              <Paper
                ref={node => {
                  refPaper.current = node;
                  setRefPaper(node);
                }}
                elevation={5} 
                // {...slotProps} 
                sx={{
                  ...slotProps?.sx,
                  transform: transform
                }}
              >
                {props.children}              
              </Paper>
            </Box>
          </Grow>          
        )}
      </Popper>
    </ClickAwayListener>
  )
});

export const Bs4PopperOld = React.forwardRef((props, ref) => {
  const {slotProps, ...other} = props  
  const theme = useTheme();
  const [visibility, setVisibility] = React.useState(true)
  const [arrowRef, setArrowRef] = React.useState(null);
  const handleClickAway = (event) => {
    // console.log('...Bs4Popper.ClickAway..', event)
    if (props.onClose) props.onClose(event);
  }

  React.useEffect(() => {
    if (!props.bs4kartotekaid) {
      return;
    }

    const bs4Kartoteka = Bs4Kartoteka.get(props.bs4kartotekaid);
    bs4Kartoteka.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);    

    return () => {
      const bs4Kartoteka = Bs4Kartoteka.get(props.bs4kartotekaid);
      if (bs4Kartoteka) bs4Kartoteka.off(setVisibility);
    }
  }, [setVisibility])  

  // console.log('...Bs4Popper...', props, {...props.slotProps})
  
  return (
    <ClickAwayListener 
      onClickAway={handleClickAway}
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
    >
      <Popper
        ref={ref}
        sx={{zIndex: theme.zIndex.modal, visibility: visibility ? Bs4Kartoteka.VISIBILITY_VISIBLE : Bs4Kartoteka.VISIBILITY_HIDDEN}}
        placement='bottom-start'
        // placement='top-start'
        {...other}
        transition
      >
        {({ TransitionProps }) => (          
          <Grow 
            {...TransitionProps} 
            timeout={200} 
            style={{ transformOrigin: '0 0 0' }}
            // style={{ transformOrigin: '0 0 0', transform: 'scale(0.5) translate(100px, 200px)'}}
          >
            <Paper 
              ref={setArrowRef} 
              elevation={5} 
              {...slotProps} 
            >
              {props.children}              
            </Paper>          
          </Grow>          
        )}
      </Popper>
    </ClickAwayListener>
  )
});

export default Bs4Popper;
  
  